export var CardUnlockMethodEnum;
(function (CardUnlockMethodEnum) {
    CardUnlockMethodEnum["AUTO"] = "AUTO";
    CardUnlockMethodEnum["MANUAL"] = "MANUAL";
})(CardUnlockMethodEnum || (CardUnlockMethodEnum = {}));
//# sourceMappingURL=card-unlock-method.enum.js.map